import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ email: "", password: "", role: "user" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    // Redirect to login if no token found
    if (!authToken) {
      navigate("/");
    }

    // Fetch users if logged in and authorized
    axios
      .get("http://localhost:4000/api/admin/users", {
        headers: { Authorization: `Bearer ${authToken}` }
      })
      .then(res => setUsers(res.data)) // Assuming the backend is sending the users list
      .catch(err => setError("Failed to load users"));
  }, [navigate, authToken]);

  const reset2FA = (email) => {
    if (window.confirm("Are you sure you want to reset 2FA for this user?")) {
      axios
        .post("http://localhost:4000/api/admin/reset-2fa", { email }, {
          headers: { Authorization: `Bearer ${authToken}` }
        })
        .then(() => {
          alert("2FA has been reset");
          window.location.reload();
        })
        .catch(err => alert("Failed to reset 2FA"));
    }
  };

  const changeRole = (email, role) => {
    if (window.confirm("Are you sure you want to switch the user's role?")) {
      axios
        .put(`http://localhost:4000/api/admin/user/${email}/role`, { role }, {
          headers: { Authorization: `Bearer ${authToken}` }
        })
        .then(() => {
          alert("Role has been switched");
          window.location.reload();
        })
        .catch(err => alert("Failed to switch role"));
    }
  };

  const deleteUser = (email) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      axios
        .delete(`http://localhost:4000/api/admin/user/${email}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        })
        .then(() => {
          alert("User has been deleted");
          window.location.reload();
        })
        .catch(err => alert("Failed to delete user"));
    }
  };

  const userEmail = localStorage.getItem("email");  // Hole die E-Mail des Benutzers aus dem LocalStorage


  const createUser = () => {
    if (!newUser.email || !newUser.password) {
      alert("Email and password are required");
      return;
    }

    axios
      .post("http://localhost:4000/api/admin/add-user", newUser, {
        headers: { Authorization: `Bearer ${authToken}` }
      })
      .then(() => {
        alert("User created successfully");
        setNewUser({ email: "", password: "", role: "user" });
        window.location.reload();
      })
      .catch(err => alert("Failed to create user"));
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <header className="flex items-center justify-between p-4 bg-gray-800 text-white">
        <button onClick={() => navigate("/")} className="flex items-center gap-2">
          <img src="/swissphone-logo.png" alt="Swissphone" className="h-10" />
          <h1 className="text-lg font-semibold">Admin Panel</h1>
        </button>
        <span>Logged in as <strong>{userEmail}</strong></span>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-semibold mb-6">User Management</h2>

        {/* New User Form */}
        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Create New User</h3>
          <input
            type="email"
            placeholder="Email"
            value={newUser.email}
            onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
            className="p-3 border border-gray-300 rounded-lg mb-4 w-full"
          />
          <input
            type="password"
            placeholder="Password"
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
            className="p-3 border border-gray-300 rounded-lg mb-4 w-full"
          />
          <select
            value={newUser.role}
            onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
            className="p-3 border border-gray-300 rounded-lg mb-4 w-full"
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
          <button
            onClick={createUser}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
          >
            Create User
          </button>
        </div>

        {/* User List */}
        <div className="overflow-x-auto shadow-lg rounded-lg">
          <table className="min-w-full table-auto">
            <thead>
              <tr>
                <th className="px-4 py-2 border-b text-left">Email</th>
                <th className="px-4 py-2 border-b text-left">Role</th>
                <th className="px-4 py-2 border-b text-left">2FA Status</th>
                <th className="px-4 py-2 border-b text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(users) && users.map((user, i) => (
                <tr key={i}>
                  <td className="px-4 py-2 border-b">{user.email}</td>
                  <td className="px-4 py-2 border-b">{user.role}</td>
                  <td className="px-4 py-2 border-b">{user.secret ? "Enabled" : "Not Enabled"}</td>
                  <td className="px-4 py-2 border-b">
                    <button
                      onClick={() => reset2FA(user.email)}
                      className="bg-yellow-600 text-white px-2 py-1 rounded mr-2"
                    >
                      Reset 2FA
                    </button>
                    <button
                      onClick={() => changeRole(user.email, user.role === "admin" ? "user" : "admin")}
                      className="bg-blue-600 text-white px-2 py-1 rounded mr-2"
                    >
                      Switch Role
                    </button>
                    <button
                      onClick={() => deleteUser(user.email)}
                      className="bg-red-600 text-white px-2 py-1 rounded"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

         {/* Error Message */}
         {error && <p className="text-red-600 mt-4 text-center">{error}</p>}
      </main>
    </div>

  );
}
